<template>
    <div>
        <subscribed-register v-if="!checkGroup"/>
        <entertain-register v-else />
    </div>
</template>
<script>
import EntertainingRegister from './EntertainRegister.vue'
import SubscribedRegister from './SubscribedRegister.vue'
import { mixins } from '../../mixin';
export default {
    mixins :[mixins],
    components:{
        'entertain-register': EntertainingRegister,
        'subscribed-register': SubscribedRegister,
    },
    methods:{
        componentsController(){
            let subscribeGroup = ['goi-vip', 'goi-max','goi-izi'];
            let serviceCode = this.$route.params['servicecode'];

            if(!serviceCode){
                if(!this.getFromSessions('ISSA')){
                    return false;
                }
                return this.getFromSessions('ISSA');
            }
            return !subscribeGroup.includes(serviceCode);

        }
    },
    mounted(){
        this.getUTM();
        localStorage.removeItem("clearedSession"); // Xoá cờ để tránh lặp
    },
    computed:{
        checkGroup(){
            this.addToSessions('ISSA',this.componentsController())
            return this.componentsController();
        }
    }
}
</script>
